'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-13d783d6.js');
var React = require('react');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

(function (ObjectFit) {
    ObjectFit["FILL"] = "fill";
    ObjectFit["CONTAIN"] = "contain";
    ObjectFit["COVER"] = "cover";
    ObjectFit["NONE"] = "none";
    ObjectFit["SCALE_DOWN"] = "scale-down";
})(exports.ObjectFit || (exports.ObjectFit = {}));
(function (Position) {
    Position["CENTER"] = "center";
    Position["TOP"] = "top";
    Position["RIGHT"] = "right";
    Position["BOTTOM"] = "bottom";
    Position["LEFT"] = "left";
})(exports.Position || (exports.Position = {}));
var StyledImage = styled__default['default'].img.withConfig({ displayName: "ww-uikit_StyledImage_l0c9i4td", componentId: "sc-1j9v08g" })(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    height: ", ";\n    object-fit: ", ";\n    width: ", ";\n\n    ", "\n"], ["\n    height: ", ";\n    object-fit: ", ";\n    width: ", ";\n\n    ",
    "\n"])), function (_a) {
    var imgHeight = _a.imgHeight;
    return imgHeight;
}, function (_a) {
    var _b = _a.objectFit, objectFit = _b === void 0 ? exports.ObjectFit.FILL : _b;
    return objectFit;
}, function (_a) {
    var imgWidth = _a.imgWidth;
    return imgWidth;
}, function (_a) {
    var objectPosition = _a.objectPosition;
    return objectPosition &&
        "object-position: " + (Array.isArray(objectPosition) ? "" + objectPosition.join(' ') : objectPosition);
});
var Image = function (_a) {
    var alt = _a.alt, className = _a.className, _b = _a.imgHeight, imgHeight = _b === void 0 ? '100%' : _b, _c = _a.imgWidth, imgWidth = _c === void 0 ? '100%' : _c, _d = _a.loading, loading = _d === void 0 ? 'lazy' : _d, objectFit = _a.objectFit, objectPosition = _a.objectPosition, sizes = _a.sizes, srcSet = _a.srcSet, url = _a.url, _e = _a.onError, onError = _e === void 0 ? function () { } : _e, _f = _a.onLoad, onLoad = _f === void 0 ? function () { } : _f;
    return (React__default['default'].createElement(StyledImage, { className: className, imgHeight: imgHeight, imgWidth: imgWidth, loading: loading, objectFit: objectFit, objectPosition: objectPosition, sizes: sizes, src: url, srcSet: srcSet, alt: alt, onError: onError, onLoad: onLoad }));
};
var templateObject_1;

exports.default = Image;
//# sourceMappingURL=index.js.map
